import React from 'react';
import { MoreVertical } from 'lucide-react';

// Standard disabled ⋯ placeholder — keeps the top-right action cluster in
// the exact same position on every tab (Jun 2026 user request). Use a real
// menu instead when the tab has extra actions.
export const DisabledHeaderDots = ({ testId = 'header-tools-menu-btn' }) => (
  <button
    disabled
    className="h-9 w-9 inline-flex items-center justify-center bg-gray-50 text-gray-300 border border-gray-200 rounded-lg cursor-not-allowed shrink-0"
    title="No additional actions"
    data-testid={testId}
  >
    <MoreVertical className="h-4 w-4" />
  </button>
);

export default DisabledHeaderDots;
